<template>
  <div class="certificates-page-container mt-2 mb-5 mx-5 mt-sm-5 mb-sm-15 mx-sm-10 rounded-xl pa-5">
    <v-row>
      <v-col>
        <v-row>
          <v-col cols="12" class="text-start">
            <v-tabs
              v-model="selectedTab"
              color="primary"
              background-color="transparent"
            >
              <v-tab
                v-for="(item, index) in tabs"
                :key="index"
                class="px-0 me-8 pe-4 py-4"
                style="min-width: 130px"
              >
                <span class="text-h5 font-weight-medium">
                  {{ item.text }}
                </span>
              </v-tab>
            </v-tabs>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-tabs-items v-model="selectedTab" class="transparent">
              <v-tab-item
                v-if="havePermissionDownloadCertificate"
                :transition="false"
              >
                <CertificatesTable />
              </v-tab-item>

              <v-tab-item
                v-if="havePermissionDownloadProfileCard"
                :transition="false"
              >
                <EmployeeProfilesTable class="col-12 col-md-10 col-lg-10 pa-0" />
              </v-tab-item>
            </v-tabs-items>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CertificatesTable from "../components/certificate-and-profile-card/CertificatesTable";
import EmployeeProfilesTable from "../components/certificate-and-profile-card/EmployeeProfilesTable";

import { hasPermission } from "@/app/user-module/helpers/authHelper";

export default {
  name: "CertificatePage",
  components: { CertificatesTable, EmployeeProfilesTable },
  data() {
    return {
      selectedTab: 0,
    };
  },
  computed: {
    tabs() {
      const items = [];

      if (this.havePermissionDownloadCertificate) {
        items.push({
          text: this.$t("user.certificatesAndProfileCard.certificate"),
        });
      }

      if (this.havePermissionDownloadProfileCard) {
        items.push({
          text: this.$t("user.certificatesAndProfileCard.profileCard"),
        });
      }

      return items;
    },
    havePermissionDownloadCertificate() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["DOWNLOAD_CERTIFICATE"],
      });
    },
    havePermissionDownloadProfileCard() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["DOWNLOAD_PROFILE_CARD"],
      });
    },
  },
};
</script>

<style scoped>
.certificates-page-container {
  background: linear-gradient(180deg, #fbfbfd 0%, #f4f5f8 100%);
  min-height: calc(100vh - 100px);
}
</style>
